import { render } from "./manyBarChart.vue?vue&type=template&id=2c79c296&scoped=true"
import script from "./manyBarChart.vue?vue&type=script&lang=js"
export * from "./manyBarChart.vue?vue&type=script&lang=js"

import "./manyBarChart.vue?vue&type=style&index=0&id=2c79c296&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c79c296"]])

export default __exports__